import { useContext } from 'react';
import { SideContext } from './sideContext';

/**
 * Hook to access the SideContext
 * @throws {Error} if used outside of SideProvider
 */
export function useSide() {
  const context = useContext(SideContext);
  if (!context) {
    throw new Error('useSide must be used within a SideProvider');
  }
  return context;
}
